export const projectData = [
  {
    id: "#12145",
    si_no: "",
    star: "",
    name: "Truelysell",
    client: "NovaWave LLC",
    pro_img: "assets/img/priority/truellysel.svg",
    client_img: "assets/img/icons/company-icon-01.svg",
    piority: "High",
    start_date: "25 Sep 2023",
    end_date: "15 Oct 2023",
    stage: "Plan",
    type: "Web App",
    status: "Active",
    value: "$03,50,000",
    hrs: "100",
    mem_image1: "assets/img/profiles/avatar-14.jpg",
    mem_image2: "assets/img/profiles/avatar-15.jpg",
    mem_image3: "assets/img/profiles/avatar-16.jpg",
    budget: "$200000",
    currently_spend: "$40000",
    Action: "",
    key: "1",
  },
  {
    id: "#12146",
    si_no: "",
    star: "",
    name: "Dreamschat",
    client: "BlueSky Industries",
    pro_img: "assets/img/priority/dreamchat.svg",
    client_img: "assets/img/icons/company-icon-02.svg",
    piority: "Medium",
    start_date: "29 Sep 2023",
    end_date: "19 Oct 2023",
    stage: "Develop",
    type: "Web App",
    status: "Inactive",
    value: "$02,15,000",
    hrs: "80",
    mem_image1: "assets/img/profiles/avatar-03.jpg",
    mem_image2: "assets/img/profiles/avatar-05.jpg",
    mem_image3: "assets/img/profiles/avatar-06.jpg",
    budget: "$300000",
    currently_spend: "$120000",
    Action: "",
    key: "2",
  },
  {
    id: "#12147",
    si_no: "",
    star: "",
    name: "Truelysell",
    client: "SilverHawk",
    pro_img: "assets/img/priority/truellysell.svg",
    client_img: "assets/img/icons/company-icon-03.svg",
    piority: "High",
    start_date: "05 Oct 2023",
    end_date: "12 Oct 2023",
    stage: "Completed",
    type: "Web App",
    status: "Active",
    value: "$01,45,000",
    hrs: "75",
    mem_image1: "assets/img/profiles/avatar-04.jpg",
    mem_image2: "assets/img/profiles/avatar-01.jpg",
    mem_image3: "assets/img/profiles/avatar-16.jpg",
    budget: "$200000",
    currently_spend: "$200000",
    Action: "",
    key: "3",
  },
  {
    id: "#12148",
    si_no: "",
    star: "",
    name: "Servbook",
    client: "SummitPeak",
    pro_img: "assets/img/priority/servbook.svg",
    client_img: "assets/img/icons/company-icon-04.svg",
    piority: "Medium",
    start_date: "14 Oct 2023",
    end_date: "24 Oct 2023",
    stage: "Design",
    type: "Web App",
    status: "Inactive",
    value: "$02,15,000",
    hrs: "60",
    mem_image1: "assets/img/profiles/avatar-12.jpg",
    mem_image2: "assets/img/profiles/avatar-15.jpg",
    mem_image3: "assets/img/profiles/avatar-13.jpg",
    budget: "$300000",
    currently_spend: "$60000",
    Action: "",
    key: "4",
  },
  {
    id: "#12149",
    si_no: "",
    star: "",
    name: "DreamPOS",
    client: "RiverStone Ventur",
    pro_img: "assets/img/priority/dream-pos.svg",
    client_img: "assets/img/icons/company-icon-05.svg",
    piority: "Low",
    start_date: "15 Nov 2023",
    end_date: "22 Nov 2023",
    stage: "Design",
    type: "Web App",
    status: "Inactive",
    value: "$03,64,000",
    hrs: "72",
    mem_image1: "assets/img/profiles/avatar-10.jpg",
    mem_image2: "assets/img/profiles/avatar-11.jpg",
    mem_image3: "assets/img/profiles/avatar-16.jpg",
    budget: "$120000",
    currently_spend: "$40000",
    Action: "",
    key: "5",
  },
  {
    id: "#12150",
    si_no: "",
    star: "",
    name: "Kofejob",
    client: "CoastalStar Co.",
    pro_img: "assets/img/priority/project-01.svg",
    client_img: "assets/img/icons/company-icon-06.svg",
    piority: "High",
    start_date: "25 Nov 2023",
    end_date: "09 Dec 2023",
    stage: "Develop",
    type: "Meeting",
    status: "Active",
    value: "$02,12,000",
    hrs: "96",
    mem_image1: "assets/img/profiles/avatar-14.jpg",
    mem_image2: "assets/img/profiles/avatar-09.jpg",
    mem_image3: "assets/img/profiles/avatar-08.jpg",
    budget: "$200000",
    currently_spend: "$90000",
    Action: "",
    key: "6",
  },
  {
    id: "#12151",
    si_no: "",
    star: "",
    name: "Doccure",
    client: "HarborView",
    pro_img: "assets/img/priority/project-02.svg",
    client_img: "assets/img/icons/company-icon-07.svg",
    piority: "Medium",
    start_date: "08 Dec 2023",
    end_date: "16 Dec 2023",
    stage: "Completed",
    type: "Web App",
    status: "Inactive",
    value: "$04,18,000",
    hrs: "85",
    mem_image1: "assets/img/profiles/avatar-06.jpg",
    mem_image2: "assets/img/profiles/avatar-07.jpg",
    mem_image3: "assets/img/profiles/avatar-16.jpg",
    budget: "$200000",
    currently_spend: "$195000",
    Action: "",
    key: "7",
  },
  {
    id: "#12152",
    si_no: "",
    star: "",
    name: "Best@laundry",
    client: "Golden Gate Ltd",
    pro_img: "assets/img/priority/best.svg",
    client_img: "assets/img/icons/company-icon-08.svg",
    piority: "Low",
    start_date: "21 Dec 2023",
    end_date: "13 Jan 2024",
    stage: "Completed",
    type: "Meeting",
    status: "Inactive",
    value: "$01,23,000",
    hrs: "65",
    mem_image1: "assets/img/profiles/avatar-04.jpg",
    mem_image2: "assets/img/profiles/avatar-15.jpg",
    mem_image3: "assets/img/profiles/avatar-05.jpg",
    budget: "$230000",
    currently_spend: "$220000",
    Action: "",
    key: "8",
  },
  {
    id: "#12153",
    si_no: "",
    star: "",
    name: "POS",
    client: "CoastalStar Inc",
    pro_img: "assets/img/priority/dream-pos.svg",
    client_img: "assets/img/icons/company-icon-06.svg",
    piority: "Medium",
    start_date: "01 Jan 2024",
    end_date: "11 Jan 2024",
    stage: "Develop",
    type: "Web App",
    status: "Inactive",
    value: "$03,64,000",
    hrs: "60",
    mem_image1: "assets/img/profiles/avatar-08.jpg",
    mem_image2: "assets/img/profiles/avatar-12.jpg",
    mem_image3: "assets/img/profiles/avatar-04.jpg",
    budget: "$200000",
    currently_spend: "$177777 ",
    Action: "",
    key: "9",
  },
  {
    id: "#12153",
    si_no: "",
    star: "",
    name: "Bookserv",
    client: "Redwood Inc",
    pro_img: "assets/img/priority/servbook.svg",
    client_img: "assets/img/icons/company-icon-09.svg",
    piority: "Medium",
    start_date: "12 Jan 2024",
    end_date: "29 Jan 2024",
    stage: "Develop",
    type: "Meeting",
    status: "Inactive",
    value: " $04,10,000",
    hrs: "56",
    mem_image1: "assets/img/profiles/avatar-12.jpg",
    mem_image2: "assets/img/profiles/avatar-14.jpg",
    mem_image3: "assets/img/profiles/avatar-01.jpg",
    budget: "$300000",
    currently_spend: "$100000 ",
    Action: "",
    key: "10",
  },
  {
    id: "#12153",
    si_no: "",
    star: "",
    name: "Dreamchat",
    client: "Redwood Inc",
    pro_img: "assets/img/priority/sports.svg",
    client_img: "assets/img/icons/company-icon-09.svg",
    piority: "Low",
    start_date: "16 Jan 2024",
    end_date: "25 Jan 2024",
    stage: "Develop",
    type: "Meeting",
    status: "Inactive",
    value: "$02,19,000",
    hrs: "55",
    mem_image1: "assets/img/profiles/avatar-08.jpg",
    mem_image2: "assets/img/profiles/avatar-15.jpg",
    mem_image3: "assets/img/profiles/avatar-12.jpg",
    budget: "$400000",
    currently_spend: "$200000 ",
    Action: "",
    key: "11",
  },
  {
    id: "#12153",
    si_no: "",
    star: "",
    name: "Sports",
    client: "Ventur",
    pro_img: "assets/img/priority/best.svg",
    client_img: "assets/img/icons/company-icon-08.svg",
    piority: "Medium",
    start_date: "12 Jan 2024",
    end_date: "29 Jan 2024",
    stage: "Develop",
    type: "Web App",
    status: "Inactive",
    value: "$01,23,000",
    hrs: "63",
    mem_image1: "assets/img/profiles/avatar-01.jpg",
    mem_image2: "assets/img/profiles/avatar-11.jpg",
    mem_image3: "assets/img/profiles/avatar-14.jpg",
    budget: "$300000",
    currently_spend: "$100000 ",
    Action: "",
    key: "12",
  },
];
